import { getGuessStatuses } from './statuses'
import { solutionIndex } from './words'
import { getStoredIsHighContrastMode } from './localStorage'
import { MAX_CHALLENGES } from '../constants/settings'

export const shareStatus = (
  guesses: string[],
  lost: boolean,
  isHardMode: boolean
) => {
  const result =
    `#AlWird ${solutionIndex + 1} ${lost ? 'X' : guesses.length}/` +
    MAX_CHALLENGES +
    ' ' +
    (lost ? '' : isHardMode ? '🥇' : '🥈') +
    '\n\n' +
    generateEmojiGrid(guesses) +
    '\nArabic Wordle'
  navigator.clipboard.writeText(result).then(
    (v) => {},
    (e) => {}
  )
  try {
    // @ts-ignore: Check if NativeAndroid is defined, before calling it
    NativeAndroid.copyToClipboard(result)
  } catch (e) {
    // Catch the exception when NativeAndroid is not defined and allow
    // the method to exit gracefully.
  }
}

export const generateEmojiGrid = (guesses: string[]) => {
  return guesses
    .map((guess) => {
      const status = getGuessStatuses(guess)
      const isHighContrast = getStoredIsHighContrastMode()
      return guess
        .split('')
        .map((_, i) => {
          switch (status[i]) {
            case 'correct':
              if (isHighContrast) {
                return '🟧'
              }
              return '🟩'
            case 'present':
              if (isHighContrast) {
                return '🟦'
              }
              return '🟨'
            default:
              if (localStorage.getItem('theme') === 'dark') {
                return '⬛'
              }
              return '⬜'
          }
        })
        .reverse()
        .join('')
    })
    .join('\n')
}
